import {
  Box,
  Collapse,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import CustomButton from "../../common/Button/CustomButton";
import { useState } from "react";
import { ISkuDetail } from "../../../models/ISkuDetail";
import { AWS_URL } from "../../../configs/constants";
import { PATH_NAME } from "../../../configs/pathName";
import { useNavigate } from "react-router-dom";
import { typo } from "../../../assets/fonts/font";
import colorConfigs from "../../../configs/colorConfigs";
import { useCart } from "../../../context/CartContext";

interface ProductCardProps {
  isActive?: boolean;
  addCartAction?: () => void;
  quickViewAction?: () => void;
  sku: ISkuDetail;
}

const ProductCard = ({
  isActive,
  addCartAction,
  quickViewAction,
  sku,
}: ProductCardProps) => {
  const theme = useTheme();

  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const [isHovered, setIsHovered] = useState(false);
  const [imgBackground, setImgBackground] = useState("var(--color-transparent)");
  const isCartEnabled = process.env.REACT_APP_ENABLE_CART === 'true';

  const navigate = useNavigate();
  const { addToCart } = useCart();

  const handleAddToCart = () => {
    addCartAction && addCartAction();
    addToCart({ sku, quantity: 1 });
  };

  const handleViewProduct = () => {
    if (sku.sku_sku) {
      navigate(PATH_NAME.PRODUCT_DETAILS(sku.slug));
    }
  };

  return (
    <Stack
      sx={{
        position: "relative",
        width: "100%",
        // width: {
        //   xs: "100%",
        //   sm: "33.33%",
        //   md: "33.33%",
        //   lg: "20%",
        //   xl: "20%",
        // },
        // maxWidth: "300px",
        margin: "0 auto",
        height: "100%",
        flexShrink: 0,
        scrollSnapAlign: "center",
        "&:hover": {
          boxShadow: "0px 4px 20px var(--color-shadow-10)",
        },
      }}
    >
      <Stack
        direction={"column"}
        spacing={2}
        sx={{
          width: "100%",
          height: "100%",
          position: "relative",
          padding: "1rem 0.5rem",
        }}
      >
        <Stack
          direction={"column"}
          sx={{
            width: "100%",
            height: "100%",
            position: "relative",
            alignItems: "center",
            justifyContent: "center",
          }}
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
          onClick={isMobile ? handleViewProduct : undefined}
        >
          <Box
            component={"img"}
            src={`${AWS_URL}/${sku.image_url}`}
            alt={sku.name}
            onError={() => setImgBackground("var(--color-white)")}
            sx={{
              width: "100%",
              height: {
                xs: "300px", // Mobile devices
                sm: "300px", // Tablets
                md: "250px", // Small laptops
                lg: "250px", // Laptops
                xl: "300px", // Large screens
              },
              objectFit: "contain",
              padding: isMobile ? "0rem" : "1rem",
              backgroundColor: imgBackground,
              ...typo.bodyContent,
            }}
          />

          <Box
            sx={{
              textAlign: "center",
              width: "100%",
              flex: 1,
              paddingX: "0.5rem",
              textOverflow: "ellipsis",
              overflow: "hidden",
              whiteSpace: "wrap",
              wordBreak: "break-word",
            }}
          >
            <Typography sx={{ ...typo.title }}>{sku.name}</Typography>
          </Box>

          <Box
            sx={{
              position: "absolute",
              width: "max-content",
              height: "max-content",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
            }}
          >
            <Collapse in={isHovered}>
              <Box
                sx={{ display: "flex", gap: "10px", flexDirection: "column" }}
              >
                <CustomButton buttonType="primary" onClick={handleViewProduct}>
                  <Typography
                    component="span"
                    sx={{ ...typo.button, color: colorConfigs.productCarouselText }}
                  >
                    View
                  </Typography>
                </CustomButton>
                {isCartEnabled && (
                  <CustomButton buttonType="primary" onClick={handleAddToCart}>
                    Add to Cart
                  </CustomButton>
                )}
              </Box>
            </Collapse>
          </Box>
        </Stack>
        <Box
          sx={{
            display: "flex",
            gap: "10px",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
        </Box>
      </Stack>
    </Stack>
  );
};

export default ProductCard;
